<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
const userStore = useMemberStore();
const baseURL = 'https://devmini.walkertour.cn';
const rootPath = "/www/wwwroot/testMiniServer/server/dist";
const EnumStandardCarGroup = {
	124:'豪9',
	77:'豪7',
	80:'舒11',
	81:'舒9',
	82:'舒5',
	83:'经9',
	84:'经7',
	85:'经5'
}
const EnumCustomerAmenity = {
	1:'举牌服务',
	2:'儿童座椅'
}
const billid = inject('billid');
const forbidEdit = ref(false);
const size = ref('default')
const labelPosition = ref('right')
const imageUrl = ref('')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})

const sizeForm = ref({
	
});
const cxOptions = ref([])
onMounted(async()=>{
	if(billid.value!=null&&billid.value!=''){
		const response = await axios.post('/klook/orders/queryDetail', {
		  billid:billid.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			sizeForm.value = response.data.data;
			imageUrl.value = sizeForm.value.cover_image
		}
	}
})
function onSubmit() {
  console.log('submit!')
}
const handleAvatarSuccess= (
  response,
  uploadFile
) => {
  if(response.status===0){
  	imageUrl.value = response.imgUrl.replace(rootPath,baseURL);
  	sizeForm.value.cover_image = response.imgUrl;
  }
}

const beforeAvatarUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
    ElMessage.error('Avatar picture must be JPG/PNG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('Avatar picture size can not exceed 2MB!')
    return false
  }
  return true
}
</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
		style="height: 500px;overflow-y: scroll;"
	  >
		<div style="display: flex;">
			<el-form-item label="订单号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.booking_reference_no}}</el-text>
			</el-form-item>
			<el-form-item label="订单状态" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.klook_order_status}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="使用时间" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.travel_time}}</el-text>
			</el-form-item>
			<el-form-item label="乘客人数" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger_num}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="国家" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.source_country}}</el-text>
			</el-form-item>
			<el-form-item label="商品" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product_id}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="备注" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.memo?.memo}}</el-text>
			</el-form-item>
		</div>
		<h4>
			乘客
		</h4>
		<div style="display: flex;">
			<el-form-item label="姓" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.last_name}}</el-text>
			</el-form-item>
			<el-form-item label="名" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.first_name}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="手机号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.phone_number}}</el-text>
			</el-form-item>
			<el-form-item label="邮箱" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.email}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="特殊要求" style="width: 98%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.customer_special_instruction}}</el-text>
			</el-form-item>
		</div>
		<h5>
			乘客其他联系方式
		</h5>
		<div style="display: flex;" v-for="(item, index) in sizeForm.passenger?.passengerOtherContact" :key="index">
			<el-form-item label="联系类型" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{item.type}}</el-text>
			</el-form-item>
			<el-form-item label="内容" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{item.content}}</el-text>
			</el-form-item>
		</div>
		<h4>
			乘客购买附加服务
		</h4>
		<div style="display: flex;" v-for="(item, index) in sizeForm.customer_amenity_service" :key="index">
			<el-form-item label="编号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{item.amenity_id}}</el-text>
			</el-form-item>
			<el-form-item label="数量" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{item.number}}</el-text>
			</el-form-item>
		</div>
		<h4>
			航班信息
		</h4>
		<div style="display: flex;">
			<el-form-item label="航线" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.airline}}</el-text>
			</el-form-item>
			<el-form-item label="航班号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.flight_number}}</el-text>
			</el-form-item>
		</div>
		<h4>
			总价
		</h4>
		<div style="display: flex;">
			<el-form-item label="单位" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.totalPrice?.currency}}</el-text>
			</el-form-item>
			<el-form-item label="总价" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.totalPrice?.amount}}</el-text>
			</el-form-item>
		</div>
		<h4>
			出发地
		</h4>
		<div style="display: flex;">
			<el-form-item label="纬度" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.latitude}}</el-text>
			</el-form-item>
			<el-form-item label="经度" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.longitude}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="名称" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.name}}</el-text>
			</el-form-item>
			<el-form-item label="地址" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.address}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="城市" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.city}}</el-text>
			</el-form-item>
			<el-form-item label="国家" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.country}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="接送机标识（有值为接机订单）" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.origin?.iata}}</el-text>
			</el-form-item>
		</div>
		<h4>
			目的地
		</h4>
		<div style="display: flex;">
			<el-form-item label="纬度" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.latitude}}</el-text>
			</el-form-item>
			<el-form-item label="经度" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.longitude}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="名称" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.name}}</el-text>
			</el-form-item>
			<el-form-item label="地址" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.address}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="城市" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.city}}</el-text>
			</el-form-item>
			<el-form-item label="国家" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.destination?.country}}</el-text>
			</el-form-item>
		</div>
		<h4>
			商品
		</h4>
		<div style="display: flex;">
			<el-form-item label="编号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?sizeForm.product.product_id:''}}</el-text>
			</el-form-item>
			<el-form-item label="确认政策" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?sizeForm.product.confirmation_policy:''}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品附加服务
		</h5>
		<div style="display: flex;" v-for="(item, index) in sizeForm.product?.amenityService" :key="index">
			<el-form-item label="编号" style="width: 30%;">
			  <el-text class="mx-1" type="primary">{{EnumCustomerAmenity[item.amenity_id]}}</el-text>
			</el-form-item>
			<el-form-item label="包含" style="width: 22%;">
			  <el-text class="mx-1" type="primary">{{item.include}}</el-text>
			</el-form-item>
			<el-form-item label="价格" style="width: 22%;">
			  <el-text class="mx-1" type="primary">{{item.price}}</el-text>
			</el-form-item>
			<el-form-item label="最大追加单位" style="width: 22%;">
			  <el-text class="mx-1" type="primary">{{item.max_purchase_unit}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品接车指引
		</h5>
		<div style="display: flex;" v-for="(item, index) in sizeForm.product?.pickupInstruction" :key="index">
			<el-form-item label="描述" style="width: 48%;">
			  <!-- <el-text class="mx-1" type="primary">{{item.text}}</el-text> -->
			  <div v-html="item.text" class="mx-1"></div>
			</el-form-item>
			<el-form-item label="图片" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{item.image}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品供应商
		</h5>
		<div style="display: flex;" >
			<el-form-item label="编号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.provider?.provider_id}}</el-text>
			</el-form-item>
			<el-form-item label="名称" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.provider?.name}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品收费
		</h5>
		<div style="display: flex;" >
			<el-form-item label="货币" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.charge?.currency}}</el-text>
			</el-form-item>
			<el-form-item label="价格" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.charge?.amount}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品车型
		</h5>
		<div style="display: flex;" >
			<el-form-item label="车型" style="width: 32%;">
			  <el-text class="mx-1" type="primary">{{EnumStandardCarGroup[sizeForm.product?.vehicle?.standard_car_group_id]}}</el-text>
			</el-form-item>
			<el-form-item label="是否保证" style="width: 32%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.vehicle?.guarantee}}</el-text>
			</el-form-item>
			<el-form-item label="保证车型" style="width: 32%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.vehicle?.guarantee_car_model_id}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品等待政策
		</h5>
		<div style="display: flex;" >
			<el-form-item label="免费等待" style="width: 32%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.waitPolicy?.free_wait_minutes}}</el-text>
			</el-form-item>
			<el-form-item label="超时价格" style="width: 64%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.waitPolicy?.timeout_wait_price}}</el-text>
			</el-form-item>
		</div>
		<h5>
			商品取消政策
		</h5>
		<div style="display: flex;" >
			<el-form-item label="免费等待" style="width: 96%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?.cancelPolicy}}</el-text>
			</el-form-item>
		</div>
	  </el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>